export default {
    data() {
        return {
            show_filters: false,
        }
    },

    methods: {
        toggleFilters(event) {
            this.show_filters = !this.show_filters;

            let caret;

            if (event.target.classList.contains('fa-caret-down')) {
                caret = event.target;
            } else {
                caret = event.target.getElementsByClassName('fa-caret-down')[0];
            }

            caret.classList.toggle('active');
            caret.closest('.plain-card').classList.toggle('collapsed');
        }
    },
}
